<template>
  <div class="basemap-panel">
    <div class="basemap-label">BASE MAP</div>
    <div class="basemap-row" id="baseMapContainer">
      <div
        v-for="(base, index) in visibleBaseMaps"
        :key="base"
        :id="'Map' + index"
        class="basemap-card"
        :class="{ 'basemap-card--active': base === currentBaseMap, 'basemap-card--focused': index === currentIndex && base !== currentBaseMap }"
        @click="base !== currentBaseMap && selectNewBase(base)"
      >
        <img :src="getBaseMapImg(base)" :alt="base" class="basemap-img" />
        <span class="basemap-name">{{ base }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.basemap-panel {
  padding: 8px 10px 10px;
  min-width: 200px;
  border-radius: 6px;
}

.basemap-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.basemap-row {
  display: flex;
  flex-direction: row;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.basemap-row::-webkit-scrollbar {
  height: 3px;
}
.basemap-row::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}
.basemap-row::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 2px;
}

.basemap-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 6px 8px 6px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease;
  flex-shrink: 0;
  width: 88px;
  overflow: hidden;
}

.basemap-card:hover:not(.basemap-card--active) {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.25);
}

.basemap-card--active {
  background: rgba(0, 123, 255, 0.25);
  border-color: #007bff;
  cursor: default;
}

.basemap-card--focused {
  border-color: rgba(255, 255, 255, 0.4);
}

.basemap-img {
  width: 100%;
  /* height: 48px; */
  object-fit: cover;
  border-radius: 2px;
  display: block;
}

.basemap-name {
  color: #fff;
  font-size: 0.65rem;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  user-select: none;
}
</style>

<script>
export default {
  name: 'MMP_CollapsedBaseMap',
  props: ['parentRef', 'currentBaseMap', 'expanded', 'map', 'isAnsiComponent', 'extentsOpen'],
  data() {
    return {
      baseMaps: ['OpenStreetMap', 'Google', 'Azure', 'Black'],
      AzureAerialImg: require('../../../assets/base_maps/azureSatellite.png'),
      BlackImg: require('../../../assets/base_maps/Black.png'),
      OpenStreetMapImg: require('../../../assets/base_maps/OpenStreetMap.png'),
      GoogleMapImg: require('../../../assets/base_maps/GoogleMap.png'),
      currentIndex: 0
    }
  },
  computed: {
    visibleBaseMaps() {
      return this.baseMaps.filter(base => base !== 'Google' || this.isAnsiComponent)
    }
  },
  methods: {
    getBaseMapImg(base) {
      switch (base) {
        case 'Azure':   return this.AzureAerialImg
        case 'Google':  return this.GoogleMapImg
        case 'Black':   return this.BlackImg
        default:        return this.OpenStreetMapImg
      }
    },
    selectNewBase(base) {
      this.$emit('toggleBaseLayer', base)
    },
    scrollToImg(id) {
      this.$nextTick(() => {
        const el = document.getElementById(id)
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      })
    },
    keyDownHandler(event) {
      if (['input', 'b-form-textarea', 'b-form-input', 'textarea'].includes(event.target.tagName.toLowerCase())) return
      if (event.key === 'ArrowLeft' && this.currentIndex > 0) {
        this.currentIndex--
        this.scrollToImg('Map' + this.currentIndex)
      } else if (event.key === 'ArrowRight' && this.currentIndex < this.visibleBaseMaps.length - 1) {
        this.currentIndex++
        this.scrollToImg('Map' + this.currentIndex)
      } else if (event.key === 'Enter') {
        const base = this.visibleBaseMaps[this.currentIndex]
        if (base !== this.currentBaseMap) this.selectNewBase(base)
      }
    },
    removeIteratorListener() {
      window.removeEventListener('keydown', this.keyDownHandler)
    },
    addIteratorListener() {
      window.addEventListener('keydown', this.keyDownHandler)
    }
  },
  mounted() {
    window.addEventListener('wheel', e => {
      const item = document.getElementById('baseMapContainer')
      let node = e.target
      while (node) {
        if (node === item) {
          item.scrollLeft += e.deltaY > 0 ? 35 : -35
          node = false
        } else {
          node = node.parentNode
        }
      }
    })
    if (this.expanded) this.addIteratorListener()
  },
  watch: {
    expanded(newValue) {
      this.$emit('baseMapsExpandChange', this.expanded)
      this.currentIndex = 0
      newValue ? this.addIteratorListener() : this.removeIteratorListener()
      this.scrollToImg('Map0')
    },
    isAnsiComponent() {
      this.currentIndex = 0
    },
    extentsOpen(newValue) {
      if (newValue) {
        this.removeIteratorListener()
      } else if (this.expanded) {
        this.addIteratorListener()
      }
    }
  }
}
</script>
